import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_v_file_input = _resolveComponent("v-file-input");
  var _component_b_form_group = _resolveComponent("b-form-group");
  return _openBlock(), _createBlock(_component_b_form_group, {
    description: $props.description,
    label: "".concat($props.label, ": ").concat($props.required ? '*' : ''),
    "label-for": $props.inputId
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_v_file_input, {
        inputId: $props.inputId,
        "data-cy": $props.inputDataCy,
        value: $data.valueInternal,
        "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
          return $data.valueInternal = $event;
        }),
        accept: $props.accept
      }, null, 8 /* PROPS */, ["inputId", "data-cy", "value", "accept"]), _createElementVNode("div", {
        class: _normalizeClass(["invalid-feedback", {
          'd-inline': $props.errors
        }])
      }, _toDisplayString($props.errors[0]), 3 /* TEXT, CLASS */)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["description", "label", "label-for"]);
}